import Cookies from "js-cookie";
import React, { createContext, useReducer } from "react";

export const AdminContext = createContext();

const initialState = {
  userObject: localStorage.getItem('userObject')
    ? JSON.parse(localStorage.getItem('userObject'))
    : null,
};

function reducer(state, action) {
  switch (action.type) {
    case "USER_LOGIN":
      const estado = { ...state, userObject: action.payload };
      return estado;

    case "USER_LOGOUT":
      return {
        ...state,
        userObject: null,
      };

    default:
      return state;
  }
}

export const AdminProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return (
    <AdminContext.Provider value={value}>{children}</AdminContext.Provider>
  );
};
